import { createContext, useContext } from 'react';
import { ChangeOwnershipStatus, NewCustomer, OwnerData, productSignaling } from '../../models/OwnershipChange';

type ChangeOwnershipContextType = {
    owner: OwnerData;
    setOwner: React.Dispatch<React.SetStateAction<OwnerData>>;
    selectedProduct: productSignaling;
    setSelectedProduct: React.Dispatch<React.SetStateAction<productSignaling>>;
    dataChangeOwnership: ChangeOwnershipStatus | null;
    setDataChangeOwnership: React.Dispatch<React.SetStateAction<ChangeOwnershipStatus | null>>;
    partyRoleId: string;
    setPartyRoleId: React.Dispatch<React.SetStateAction<string>>;
    partyRoleType: string;
    setPartyRoleType: React.Dispatch<React.SetStateAction<string>>;
    isOpenOnboarding: boolean;
    setIsOpenOnboarding: React.Dispatch<React.SetStateAction<boolean>>;
    newCustomer: NewCustomer;
    setNewCustomer: React.Dispatch<React.SetStateAction<NewCustomer>>;
    ibanInterested: string;
    setIbanInterested: React.Dispatch<React.SetStateAction<string>>;
    flowStartUrl: string;
    setFlowStartUrl: React.Dispatch<React.SetStateAction<string>>;
    resetData: () => void;
    contactMediaOTP: string;
    setContactMediaOTP: React.Dispatch<React.SetStateAction<string>>;
    contactMediaOTPId: string;
    setContactMediaOTPId: React.Dispatch<React.SetStateAction<string>>;
    customerId: string;
    setCustomerId: React.Dispatch<React.SetStateAction<string>>;
};

export const ChangeOwnershipContext = createContext({} as ChangeOwnershipContextType);

export const useChangeOwnershipContext = () => {
    const context = useContext(ChangeOwnershipContext);

    if (!context) throw new Error('useChangeOwnershipContext must be used within a ChangeOwnershipProvider');
    return context;
};
